import { Component, Input } from '@angular/core';

@Component({
  selector: 'ig-audio-player',
  templateUrl: './audio.player.component.html',
  styleUrl: './audio.player.component.scss',
})
export class AudioPlayerComponent {
  @Input() public audio: {
    isActive: boolean;
    link: string;
    description: string;
  };

  @Input() textColor = 'text-gray-200';
}
